import { lazy } from 'react';

// Lazy load all page components for better performance and code splitting
export const LazyHome = lazy(() => import('./Home'));
export const LazyAbout = lazy(() => import('./About'));
export const LazyEvents = lazy(() => import('./Events'));
export const LazyCalendar = lazy(() => import('./Calendar'));
export const LazyGallery = lazy(() => import('./Gallery'));
export const LazyMembership = lazy(() => import('./Membership'));
export const LazyJoinNow = lazy(() => import('./JoinNow'));
export const LazyTerms = lazy(() => import('./Terms'));
export const LazyPrivacy = lazy(() => import('./Privacy'));
export const LazyAdmin = lazy(() => import('./Admin'));

// Lazy load admin components separately for better bundle splitting
export const LazyAdminDashboard = lazy(() => import('../components/admin/AdminDashboard'));
export const LazyUserManagement = lazy(() => import('../components/admin/UserManagement'));
export const LazyContentManagement = lazy(() => import('../components/admin/ContentManagement'));
export const LazyApplicationSubmissions = lazy(() => import('../components/admin/ApplicationSubmissions'));
export const LazyAuditLogs = lazy(() => import('../components/admin/AuditLogs'));
export const LazySystemConfiguration = lazy(() => import('../components/admin/SystemConfiguration'));

// Lazy load chart components separately
export const LazyAnalyticsDashboard = lazy(() => import('../components/admin/AnalyticsDashboard'));
export const LazyModernAnalyticsDashboard = lazy(() => import('../components/admin/ModernAnalyticsDashboard'));
export const LazySearchPerformanceDashboard = lazy(() => import('../components/admin/SearchPerformanceDashboard'));

// Preload functions for better UX
export const preloadHome = () => import('./Home');
export const preloadAbout = () => import('./About');
export const preloadEvents = () => import('./Events');
export const preloadCalendar = () => import('./Calendar');
export const preloadGallery = () => import('./Gallery');
export const preloadMembership = () => import('./Membership');
export const preloadJoinNow = () => import('./JoinNow');
export const preloadTerms = () => import('./Terms');
export const preloadPrivacy = () => import('./Privacy');
export const preloadAdmin = () => import('./Admin');
